module.exports = "/_next/static/resources/life1-455e493badcc6c3e4cad22b33a26fb5a.jpg";